module.exports = __webpack_public_path__ + "img/share-indicte.469a5ab6.png";